import axios from "axios";
import qs    from "qs";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  withCredentials: true,
  timeout: 10000,     
  paramsSerializer: params =>
    qs.stringify(params, {
      arrayFormat: "repeat", 
      encodeValuesOnly: true,  
    }),                       
});

api.interceptors.request.use((config) => {
  const sessionToken = localStorage.getItem("bd2mSessionToken");
  if (sessionToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${sessionToken}`;
  }
  return config;
});

export default api;
